import React, { Component } from 'react';
const footer = require('./images/footer.png');

export default class CopyrightAd extends Component {

  render() {
    return (
      <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
        <img src={footer} alt="Crazylister" title="Crazylister"/>
      </div>
    );
  }
}
